//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
export default {
  data: function data() {
    return {
      selectedIndex: 0,
      selectedIndex1: 0,
      selectedIndex2: 0,
      selectedIndex3: 0,
      tabListShow: false
    };
  },
  props: ['standardList', 'airStandardList', 'wasteStandardList', 'wasteAirStandardList', 'standShape', 'standShape1', 'onlineStateList', 'st', 'showMapTag', 'standardLists'],
  created: function created() {}
};